import swal from "sweetalert";
import { API } from "../Services/api-services";
import { decrypt, encrypt } from "../utils/others";

const sessionExpired = (forceReload = false) => {
  swal({
    title: "Session Expired",
    text: "Continue working?",
    icon: "warning",
    buttons: ["No, go to home page.", "Yes, Login"],
    closeOnClickOutside: false,
    closeOnEsc: false,
  }).then((login) => {
    if (login) {
      const userObj = localStorage.getItem("user");
      const user = decrypt(userObj);
      const username = user.user_name;
      swal({
        title: "Login",
        text: "Enter your password.",
        content: {
          element: "input",
          attributes: {
            placeholder: "Type your password",
            type: "password",
          },
        },
        closeOnClickOutside: false,
        closeOnEsc: false,
      })
        .then((password) => {
          return API.post("/login", {
            user_name: username,
            password: password,
          });
        })
        .then((res) => {
          if (res) {
            const encryptedUserData = encrypt(res.data);
            localStorage.setItem("user", encryptedUserData);
            window.location.reload();
          }
        })
        .catch((e) => {
          if (e.response?.data?.msg === "Wrong Password") {
            localStorage.removeItem("user");
            window.location.replace("/");
          }
        });
    } else {
      localStorage.removeItem("user");
      window.location.replace("/");
    }
  });
};

export default sessionExpired;
